import { render, staticRenderFns } from "./LoadingWithText.vue?vue&type=template&id=2277e92e"
import script from "./LoadingWithText.vue?vue&type=script&lang=ts"
export * from "./LoadingWithText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports